var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelfserve = function SvgSelfserve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M3 27a2 2 0 0 1 2-2h60a2 2 0 0 1 2 2v21a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm25.5 4a1.5 1.5 0 0 1 1.5-1.5h27a1.5 1.5 0 1 1 0 3H30a1.5 1.5 0 0 1-1.5-1.5m1.5 4.5a1.5 1.5 0 0 0 0 3h31a1.5 1.5 0 1 0 0-3zM28.5 43a1.5 1.5 0 0 1 1.5-1.5h25a1.5 1.5 0 1 1 0 3H30a1.5 1.5 0 0 1-1.5-1.5m-17-6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m4.5-7.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B4CFFF",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M37.667 14.333 27 21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C9BF1",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M21.667 5 19 18.333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFD2A8",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "m3 7.667 8 12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    d: "m33.726 54.726 11.194-4.538q.562-.217.82-.67.26-.455.26-.93t-.28-.929q-.282-.454-.844-.67L18.34 37.135q-.518-.216-.994-.086-.475.13-.821.475t-.475.821.086.994l9.854 26.537q.216.562.67.843t.93.281q.474 0 .929-.26.453-.258.67-.82z"
  })));
};
export default SvgSelfserve;